/************************************************************************** 
 * 
 * 
 * In order for this to work, you must provide a container with 
 * position:relative, otherwise it will take up the whole page
 * 
 * 
 * ************************************************************************/
define(function (require) {
	var showLoader = function(loader){
		loader.overlay.removeClass('clear');

		var loadingPrompt = i18n.t('CIVICS.COMMON.LOADING');
		var mainLoader = $('<div class="loading-indicator" aria-live="polite"></div>');
		var loadingLabel = $('<p class="loading-label">' + loadingPrompt + '</p>');
		var animator = $('<div class="animation-container"> </div>');

		for (var i = 0; i < 12; i++) {
			animator.append('<div class="key"></div>');
		}
		mainLoader.append(animator);
		mainLoader.append(loadingLabel);

		mainLoader.appendTo(loader.overlay);
	};
	return {
		loading:function(show,view, force, delay = 500){
			if(!view || !view.$el){
				return;
			}
			if(view.loader==null){
				view.loader = {};
			}
			var loader = view.loader;

			if(show === false && force === true){
				loader.loadCounter = 0;
			}

			if(show === true){
				if(isNaN(loader.loadCounter)){
					loader.loadCounter = 1;
				} else {
					loader.loadCounter++;
				}

				if(loader.loadCounter === 1){
					loader.overlay = $('<div id="overlay" class="rhy loading-portlet absolute-position clear"> </div>');
					view.$el.append(loader.overlay);
					if(delay > 0){
						loader.overlayDelay = setTimeout(showLoader(loader),delay);
					} else {
						showLoader(loader,delay);
					}
				}
			} else {
				if (!loader.loadCounter)
					loader.loadCounter = 0;
				else {
					loader.loadCounter--;
				}

				if (loader.loadCounter === 0) {
					if (loader.overlayDelay)
						clearTimeout(loader.overlayDelay);

					if (loader.overlay) {
						loader.overlay.remove();
					} else if(view.$el.find('#overlay').length == 1){
						view.$el.find('#overlay').remove();
					}
				}
			}
		}
	};
});
